import createIcon from '../../createIcon';

/**
 * @component @name Extension
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTEuNUgxOC41VjcuNUMxOC41IDYuNCAxNy42IDUuNSAxNi41IDUuNUgxMi41VjRDMTIuNSAyLjYyIDExLjM4IDEuNSAxMCAxLjVDOC42MiAxLjUgNy41IDIuNjIgNy41IDRWNS41SDMuNUMyLjQgNS41IDEuNTEgNi40IDEuNTEgNy41VjExLjNIM0M0LjQ5IDExLjMgNS43IDEyLjUxIDUuNyAxNEM1LjcgMTUuNDkgNC40OSAxNi43IDMgMTYuN0gxLjVWMjAuNUMxLjUgMjEuNiAyLjQgMjIuNSAzLjUgMjIuNUg3LjNWMjFDNy4zIDE5LjUxIDguNTEgMTguMyAxMCAxOC4zQzExLjQ5IDE4LjMgMTIuNyAxOS41MSAxMi43IDIxVjIyLjVIMTYuNUMxNy42IDIyLjUgMTguNSAyMS42IDE4LjUgMjAuNVYxNi41SDIwQzIxLjM4IDE2LjUgMjIuNSAxNS4zOCAyMi41IDE0QzIyLjUgMTIuNjIgMjEuMzggMTEuNSAyMCAxMS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Extension = createIcon('Extension', [
  [
    'path',
    {
      d: 'M20 11.5H18.5V7.5C18.5 6.4 17.6 5.5 16.5 5.5H12.5V4C12.5 2.62 11.38 1.5 10 1.5C8.62 1.5 7.5 2.62 7.5 4V5.5H3.5C2.4 5.5 1.51 6.4 1.51 7.5V11.3H3C4.49 11.3 5.7 12.51 5.7 14C5.7 15.49 4.49 16.7 3 16.7H1.5V20.5C1.5 21.6 2.4 22.5 3.5 22.5H7.3V21C7.3 19.51 8.51 18.3 10 18.3C11.49 18.3 12.7 19.51 12.7 21V22.5H16.5C17.6 22.5 18.5 21.6 18.5 20.5V16.5H20C21.38 16.5 22.5 15.38 22.5 14C22.5 12.62 21.38 11.5 20 11.5Z',
      key: '2mxe9v',
    },
  ],
]);

export default Extension;
